import { Directive, ElementRef, HostListener, Input, OnInit, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: 'input[unit]',
    standalone: true
})
export class InputUnitDirective implements OnInit {
  @Input() unit: string;

  private units: string[] = [];
  constructor(private el: ElementRef, @Optional() private control: NgControl) {}

  ngOnInit(): void {
    if (this.unit) {
      this.units = [this.unit];
      if (this.unit.search('²') > -1) {
        this.units.push(this.unit.replace('²', '2'));
      }
      if (this.unit.search('³') > -1) {
        this.units.push(this.unit.replace('³', '3'));
      }
    }
  }

  @HostListener('blur', ['$event.target'])
  onEvent(target: HTMLInputElement) {
    if (this.control && this.unit && target.value) {
      this.units.forEach(e => this.control.control.setValue(target.value.replace(e, '').trim()));
    }
  }
}
